import React from 'react';

const AnalysisToolsSection = ({
  user,
  setPage,
  setShowLoginPrompt,
  setLoginPromptMessage
}) => {
  const tools = [
    
    {
      label: 'Company Intel',
      page: 'company-intel',
      requiresLogin: true,
      loginMessage: 'Please log in to access Company Intelligence.'
    },
    {
      label: 'Citations',
      page: 'citations',
      requiresLogin: true,
      requiresTier: 'premium',
      loginMessage: 'Please log in to access Citation Analysis.',
      tierMessage: 'Citation Analysis requires Premium. Upgrade to see which companies cite each other and identify technology leaders.'
    },
    {
      label: 'Network',
      page: 'network',
      requiresLogin: true,
      requiresTier: 'premium',
      loginMessage: 'Please log in to access Citation Network visualization.',
      tierMessage: 'Citation Network requires Premium. Upgrade to visualize patent citation relationships.'
    },
    
    {
      label: 'Compare Pro',
      page: 'comparison-workspace',
      requiresTier: 'pro',
      tierMessage: 'Comparison Workspace requires Pro subscription. Upgrade to unlock cross-organization patent comparison with AI-powered analysis perfect for due diligence, licensing, and competitive intelligence.'
    },
    {
      label: 'Prior Art',
      page: 'prior-art',
      requiresTier: 'pro',
      tierMessage: 'Prior Art Reports require Pro subscription. Upgrade to unlock attorney-grade prior art analysis with claim charts and comprehensive PDF reports.'
    },
    {
      label: 'FTO Pro',
      page: 'fto-pro',
      requiresTier: 'pro',
      tierMessage: 'FTO Pro requires Pro subscription. Upgrade to unlock professional Freedom to Operate analysis with counsel-grade patent risk assessment, design-around strategies, and attorney-ready reports.'
    }
  ];

  const handleToolClick = (tool) => {
  // Check login requirement
  if (tool.requiresLogin && !user) {
    setLoginPromptMessage(tool.loginMessage);
    setShowLoginPrompt(true);
    return;
  }

  // Check tier requirement
  if (tool.requiresTier) {
    if (tool.requiresTier === 'premium' && user?.tier === 'free') {
      setLoginPromptMessage(tool.tierMessage);
      setShowLoginPrompt(true);
      return;
    }
    if (tool.requiresTier === 'pro' && user?.tier !== 'pro') {
      setLoginPromptMessage(tool.tierMessage);
      setShowLoginPrompt(true);
      return;
    }
  }

  // Special handling for Compare Pro - clear workspace for fresh start
  if (tool.page === 'comparison-workspace') {
    localStorage.removeItem('comparisonWorkspacePatents');
    localStorage.removeItem('yourPatentNumber');
  }

  // Navigate to page
  setPage(tool.page);
};

  return (
    <div style={{ width: '100%', borderTop: '1px solid #e0e0e0', paddingTop: '16px' }}>
      <div style={{
        fontSize: '11px',
        fontWeight: '600',
        color: '#666',
        marginBottom: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Analysis Tools - For detailed research
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {tools.map((tool) => (
          <button
            key={tool.page}
            type="button"
            onClick={() => handleToolClick(tool)}
            style={{
              padding: '10px 16px',
              borderRadius: '8px',
              border: tool.requiresTier === 'pro' ? '2px solid #0369a1' : '2px solid #e0e0e0',
              background: tool.requiresTier === 'pro' ? '#eff6ff' : 'white',
              color: tool.requiresTier === 'pro' ? '#0369a1' : '#666',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '13px'
            }}
          >
            {tool.label}
            {tool.requiresTier === 'pro' && (
              <span style={{
                marginLeft: '6px',
                background: '#0369a1',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '10px',
                fontWeight: '600'
              }}>
                PRO
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AnalysisToolsSection;
